import axiosServices from '../utils/axios';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

export const updateJoyrideConfig = async (data) => {
  return axiosServices.put(`${backendUrl}/joyride/config`, data);
};
